/** @jsx jsx */

import { Fragment } from 'react';

import { jsx } from '@emotion/core';

type Props = {
  accountHeading?: string;
  name?: string;
};

const AuthDropdownLabel = ({ accountHeading, name }: Props) => {
  return <Fragment>{accountHeading || `${name || 'Your'} account:`}</Fragment>;
};

export default AuthDropdownLabel;
